<template>
  <div>
    <!-- <div class="nav_pos">当前位置：<label class="index" @click.stop="$router.push('/')">首页</label>>公司新闻</div>-->
    <div class="nav_pos">
      <span class="text">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in breadUrl" :key="index">
          <router-link v-if="item.url" :to="item.url">{{ item.name }}</router-link>
          <a v-else>{{ item.name }}</a>
        </el-breadcrumb-item>
        <div class="searchWrap">
          <el-input class="searchInput" v-model="searchInput" placeholder="请输入搜索内容" @keyup.enter.native="searchDetail()">
            <i class="el-icon-search elIconSearch_cus1" slot="suffix" @click.stop="searchDetail()"></i>
          </el-input>
        </div>
      </el-breadcrumb>
    </div>
    <div class="top_line">
      <LeftTab :info="info" @switchCon="switchPage"></LeftTab>
      <div style="flex: 1">
        <!-- <div class="searchWrap">
          <label class="text">搜索</label>
          <el-input class="searchInput" suffix-icon="el-icon-search" v-model="searchInput"></el-input>
          <span class="text2">为您找到<label class="red">369</label>条结果</span>
        </div> -->
        <div v-if="NewsList.length > 0">
          <div class="news_list list_wrap" v-for="(item, index) in NewsList" :key="index" @click.stop="goDetail(item.content)">
            <img class="img" :src="baseURL + item.nailUrl" />
            <div class="content_wrap" style="flex: 1">
              <div class="title clear">
                {{ item.title }}
                <span class="fr tit_fr" @click.stop="goDetail(item.content)">详细内容></span>
              </div>
              <!-- <div class="content" v-html="HTMLDecode(item.content)">...</div> -->
              <div class="date">{{ item.date }}</div>
            </div>
          </div>
        </div>
        <el-pagination class="page_wrap" background :page-size="pageSize" layout="prev, pager, next" :total="quesLength" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LeftTab from '@/components/common/LeftTab'
export default {
  name: 'news',
  components: { LeftTab },
  data() {
    return {
      initialId: '',
      breadUrl: {},
      pageIndex: 1,
      pageSize: 11,
      quesLength: 100,
      searchInput: '',
      infoData: {},
      info: {
        //左边tab的数据
        imgUrl: require('../../assets/img/icon_companynews.png'),
        text: '公司新闻',
        egText: 'Company news',
        tabList: []
      },
      NewsList: []
    }
  },
  mounted() {
    sessionStorage.setItem('IndexTab', 'news')
    this.getRequest('/Information/Index')
      .then((res) => {
        var data = res.data
        if (data.errcode == 0) {
          this.initialId = data.news.Id
          this.getList(this.initialId)
          this.getCates()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  methods: {
    getCates() {
      let config = {
        params: {
          cateId: this.initialId
        }
      }
      this.getRequest('/Information/GetCates', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.info.tabList = data.cateList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getList(cateId) {
      let config = {
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          cateId: cateId,
          title: this.searchInput
        }
      }
      this.getRequest('/Information/GetList', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.quesLength = data.quesLength
            this.NewsList = data.infoList
            this.breadUrl = data.nav
            // this.NewsList = data.infoList.filter(item => {
            // 	item.content = item.content.substr(0, 100) + '...';
            // 	return item;
            // });
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    switchPage(id) {
      this.getList(id)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getList(this.initialId)
    },
    // goDetail(index) {
    // 	//去到列表详细页
    // 	let routerData = this.$router.resolve({
    // 		name: 'detail',
    // 		query: { id: index, cateId: this.initialId, purchaseType: 0 }
    // 	});
    // 	window.open(routerData.href, '_blank');
    // },
    goDetail(url) {
      window.open(url, '_blank')
    },
    searchDetail() {
      this.pageIndex = 1
      this.getList(this.initialId)
    }
  }
}
</script>
<style scoped lang="scss">
.news_list {
  cursor: pointer;
}
.nav_pos .el-breadcrumb {
  position: relative;
  display: block;
}
.searchWrap {
  display: flex;
  position: absolute;
  right: 0;
  top: -7px;
  span {
    font-weight: bold;
  }
  ::v-deep.el-input__suffix {
    top: 3px;
  }
}
</style>
